import { z } from 'zod'

const envSchema = z.object({
  VITE_PUBLIC_SUPABASE_URL: z.string().url(),
  VITE_PUBLIC_SUPABASE_ANON_KEY: z.string().min(1),
})

// Fail fast at boot if env is misconfigured — the error message lists exactly
// what's missing so Diogo doesn't chase a blank screen.
const parsed = envSchema.safeParse(import.meta.env)
if (!parsed.success) {
  const issues = parsed.error.issues.map((i) => `  - ${i.path.join('.')}: ${i.message}`).join('\n')
  throw new Error(`Invalid client env — fix apps/web/.env.local or .env:\n${issues}`)
}

export const env = parsed.data
